/**
 * Analytics feature names — used as the first argument to trackFeature()
 */
export const ANALYTICS_FEATURES = {
  // Authentication
  AUTH: 'auth',

  // MFA
  MFA: 'mfa',

  // User profile
  COMPLETE_PROFILE: 'complete_profile',
  USER_PROFILE: 'user_profile',

  // Projects
  PROJECTS: 'projects',
  PROJECT_DETAIL: 'project_detail',
  PROJECT_EDITING: 'project_editing',
  SUBMIT_PROJECT: 'submit_project',
  CO_INVEST: 'co_invest',

  // Data Room
  DATAROOM: 'dataroom',

  // Intelligence Platform
  INTELLIGENCE_PLATFORM: 'intelligence_platform',
  GLOBAL_INFRASTRUCTURE: 'global_infrastructure',
  INVESTOR_INTELLIGENCE: 'investor_intelligence',
  INSIGHTS_SHELL: 'insights_shell',

  // Portfolio
  PORTFOLIO: 'portfolio',

  // Admin
  ADMIN: 'admin',
  ADMIN_PROJECT_CHAT: 'admin_project_chat',

  // Chatbot
  CHATBOT: 'chatbot',

  // Blog
  BLOG: 'blog',

  // Demo / Contact
  BOOK_DEMO: 'book_demo',
  CONTACT: 'contact',

  // Organization
  ORGANIZATION: 'organization',

  // PDF / Documents
  PDF_GENERATION: 'pdf_generation',
  DOCUMENT: 'document',

  // Notes
  PROJECT_NOTES: 'project_notes',

  // Public pages
  HOMEPAGE: 'homepage',
  ABOUT: 'about',
  TEAM: 'team',
  CAREERS: 'careers',
  CASE_STUDIES: 'case_studies',
  CASE_STUDY_DETAIL: 'case_study_detail',
  PUBLICATIONS: 'publications',
  PUBLICATION_DETAIL: 'publication_detail',
  HELP: 'help',
  DOCUMENTATION: 'documentation',
  TERMS: 'terms',
  PRIVACY_PAGE: 'privacy_page',
  ERROR_404: 'error_404',
  ERROR_BOUNDARY: 'error_boundary',

  // Auth flow pages
  VERIFY_EMAIL: 'verify_email',
  RESET_PASSWORD: 'reset_password',
  RESET_PASSWORD_COMPLETE: 'reset_password_complete',
  PENDING_APPROVAL: 'pending_approval',
  AUTH_HANDLER: 'auth_handler',

  // Landing pages
  INVEST_LANDING: 'invest_landing',
  SUBMIT_LANDING: 'submit_landing',
  WEDGE_MARKET_INTELLIGENCE: 'wedge_market_intelligence',
  WEDGE_2_AUDITABLE_RESEARCH: 'wedge_2_auditable_research',
  WEDGE_3_MANAGEMENT_SCAN: 'wedge_3_management_scan',
  STUDIO_LANDING: 'studio_landing',

  // Workshop
  WORKSHOP: 'workshop',

  // Risk Monitor
  RISK_MONITOR: 'risk_monitor',

  // Document Studio
  DOCUMENT_STUDIO: 'document_studio',

  // Intelligence sub-features
  COUNTRY_SEARCH: 'country_search',
  FINANCIAL_INCLUSION: 'financial_inclusion',

  // Insight module dashboards
  INSIGHT_OECD_CORPORATE_TAX: 'insight_oecd_corporate_tax',
  INSIGHT_OECD_FDI: 'insight_oecd_fdi',
  INSIGHT_CLIMATE_INDICATORS: 'insight_climate_indicators',
  INSIGHT_COUNTRIES: 'insight_countries',
  INSIGHT_ENTERPRISE_SURVEYS: 'insight_enterprise_surveys',
  INSIGHT_EXTERNAL_DEBT: 'insight_external_debt',
  INSIGHT_FINANCIAL_INCLUSION: 'insight_financial_inclusion',
  INSIGHT_GOVERNANCE_RESILIENCE: 'insight_governance_resilience',
  INSIGHT_HCI: 'insight_hci',
  INSIGHT_MACRO_OUTLOOK: 'insight_macro_outlook',
  INSIGHT_INCOME_LADDER: 'insight_income_ladder',
  INSIGHT_INDICATOR_FABRIC: 'insight_indicator_fabric',
  INSIGHT_POVERTY_COMPASS: 'insight_poverty_compass',
  INSIGHT_LOAN_INTEREST_RATES: 'insight_loan_interest_rates',
} as const;

export type AnalyticsFeature = typeof ANALYTICS_FEATURES[keyof typeof ANALYTICS_FEATURES];
